import styled, { css } from 'styled-components';

import { media } from 'styles/utils';

import { Button } from '../Button';

export const TabsContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 16px;
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 0 24px;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  -webkit-overflow-scrolling: touch;

  ::-webkit-scrollbar {
    display: none;
  }

  ${media.tablet`
    justify-content: center;
    margin: 0;
  `}
`;

export const TabsButton = styled(Button)<TabsButtonProps>`
  background-color: transparent;
  border: 2px solid ${({ theme }) => theme.colors.gray.border};
  color: ${({ theme }) => theme.colors.black};
  height: 48px;
  text-align: center;
  width: ${({ $width }) => `${$width}px` || 'auto'};

  :hover,
  :focus {
    background-color: ${({ theme }) => theme.colors.primary};
    border: 2px solid ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.white};
  }

  ${({ theme, $isActive }) =>
    $isActive &&
    css`
      background-color: ${theme.colors.primary};
      border: 2px solid ${theme.colors.primary};
      color: ${theme.colors.white};
    `};
`;

type TabsButtonProps = {
  $isActive: boolean;
  $width?: number;
};
